import { Config } from '@cian/config/shared';
import { setup as setupHttpApi, init as initHttpApi } from '@cian/http-api/browser';
import { createLogger } from '@cian/microservices-tools/logger/browser';
import { configureSentry } from '@cian/microservices-tools/sentry/browser';
import { setup as setupTelemetry, init as initTelemetry } from '@cian/telemetry/browser';
import { IBrowserAppContext } from '../../types/app';

export interface IPrepareApplicationParams {
  config: Config;
}

export async function prepareApplication(params: IPrepareApplicationParams): Promise<IBrowserAppContext> {
  try {
    const { config } = params;

    const projectName = config.get<string>('projectName');

    if (!projectName) {
      throw new Error('Project name not found');
    }

    const logger = createLogger(config);

    try {
      await configureSentry(config, {
        matchUrl: url => {
          return url.indexOf(projectName) >= 0;
        },
      });
    } catch (error) {
      logger.error('Sentry initialize failed', { error });
    }

    setupTelemetry();
    setupHttpApi({});

    const httpApi = initHttpApi();
    const telemetryLogger = initTelemetry();

    return {
      config,
      httpApi,
      logger,
      telemetryLogger,
    };
  } catch (error) {
    throw error;
  }
}
